import { getDashboard } from '@apis';
import Summary from '@assets/images/summary.svg'
import { Dashboard } from '@components';
import { generateCO2Data, generateSavingData, getLocalStorage, reduceDataSets } from '@helpers';
import { useGetPlantList } from '@hooks';
import { useQueries } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useMemo } from 'react';

const DashboardSummaryContainer = ({ logoImage }) => {
  const dateToday = dayjs();
  const { data: plantList = [] } = useGetPlantList();

  const queryResult = useQueries({
    queries: plantList?.map((plant) => {
      return {
        queryFn: () => getDashboard(plant.plant_id),
        queryKey: ['dashboardSummary', { plant_id: plant.plant_id }],
        enabled: Boolean(plant.plant_id),
      };
    }),
  });

  const isEng = getLocalStorage('LANGUAGE') === 'en';

  const dashboardData = {
    pvGenerationDay: 0,
    pvGenerationTotal: 0,
    co2: 0,
    currency: 0,
    pvPower: 0,
    peakPower: 0,
    power: '0',
    systemInfo: {
      peakPower: '0',
      startUpUtc: '',
      dcPowerInputMax: '0',
    },
    co2Reduction: 0,
    co2ReductionTotal: 0,
    totalSavingLife: 0,
    totalSavingDay: 0
  };

  const graphs = []

  queryResult
    .filter((result) => result.isSuccess && result.data !== null)
    .forEach((result) => {
      dashboardData.pvGenerationDay += parseFloat(result.data.pvGenerationDay);
      dashboardData.pvGenerationTotal += parseFloat(result.data.pvGenerationTotal);
      dashboardData.co2 += parseFloat(result.data.co2);
      dashboardData.currency += parseFloat(result.data.currency);
      dashboardData.pvPower += parseFloat(result.data.pvPower);
      dashboardData.peakPower += parseFloat(result.data.peakPower);
      dashboardData.co2Reduction += generateCO2Data(parseFloat(result.data.pvGenerationDay), parseFloat(result.data.co2))
      dashboardData.co2ReductionTotal += generateCO2Data(parseFloat(result.data.pvGenerationTotal), parseFloat(result.data.co2));
      dashboardData.totalSavingDay += generateSavingData(parseFloat(result.data.pvGenerationDay), parseFloat(result.data.currency));
      dashboardData.totalSavingLife += generateSavingData(parseFloat(result.data.pvGenerationTotal), parseFloat(result.data.currency));

      const peakPower = parseFloat(dashboardData.systemInfo.peakPower) + parseFloat(result.data.systemInfo.peakPower)
      const dcPowerInputMax = parseFloat(dashboardData.systemInfo.dcPowerInputMax) + parseFloat(result.data.systemInfo.dcPowerInputMax)

      if (dashboardData.systemInfo.startUpUtc === '') {
        dashboardData.systemInfo.startUpUtc = result.data.systemInfo.startUpUtc
      }

      let power
      if (result.data.temperature?.typeDeviceDataM) {
        power =  parseFloat(dashboardData.power) + parseFloat(result.data.systemInfo.dcPowerInputMax)
      } else if (result.data.systemInfo?.peakPower) {
        power = parseFloat(dashboardData.power) + parseFloat(result.data.systemInfo.peakPower)
      }

      dashboardData.power = power.toString()
      dashboardData.systemInfo.peakPower = peakPower.toString()
      dashboardData.systemInfo.dcPowerInputMax = dcPowerInputMax.toString()

      graphs.push(result.data.graph)
    });

  const graph = useMemo(() => reduceDataSets(graphs), [graphs]);
  const Logo = <>
    <img className='logo' src={logoImage} alt={logoImage} />
    <img className='logo' src={Summary} alt={Summary} />
  </>


  return (
    dashboardData && (
      <Dashboard
        plantId={'1'}
        isEng={isEng}
        logo={Logo}
        power={dashboardData.power}
        temperature={queryResult[0]?.data?.temperature}
        pvGenerationDay={dashboardData.pvGenerationDay}
        pvGenerationTotal={dashboardData.pvGenerationTotal}
        dateToday={dateToday}
        address={queryResult[0]?.data?.address}
        systemInfo={dashboardData.systemInfo}
        peakPower={dashboardData.peakPower}
        graph={graph}
        pvPower={dashboardData.pvPower}
        co2={dashboardData.co2}
        currency={dashboardData.currency}
        co2Reduction={dashboardData.co2Reduction}
        co2ReductionTotal={dashboardData.co2ReductionTotal}
        totalSavingLife={dashboardData.totalSavingLife}
        totalSavingDay={dashboardData.totalSavingDay} />
    )
  );
};

export default DashboardSummaryContainer;